var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"setting"}},[_c('CameraMenu'),_c('MicMenu'),_c('SpeakerMenu'),_c('SettingMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }